import { createContext } from 'react';

export const QuotedContext = createContext<boolean>(false);
